module.exports = __webpack_public_path__ + "img/iStock-474451428.dc9d50b5.jpg";